const React = require('react');
const ContextProviders = require('src/hooks/ContextProviders').default;
const { I18nProvider } = require('src/hooks/useI18nContext');
const { SpacingGlobalVariables } = require('src/app/styles/spacing');
const { initTrackInteractionListener } = require('src/functions/analytics/trackInteractionListener');
const {
  resetPageLoadTimestamp,
  incrementSessionPageCount,
  captureUtmParams,
} = require('src/functions/analytics/pageState');
const { initScrollMilestoneTracking, resetScrollMilestones } = require('src/functions/analytics/trackScrollMilestones');
const { initQualitySessionTracking, checkQualitySessionOnRouteUpdate } = require('src/functions/analytics/trackQualitySession');
const { pushRouteUpdate } = require('src/functions/analytics/pushRouteUpdate');

exports.onClientEntry = () => {
  initTrackInteractionListener();
  initScrollMilestoneTracking();
  initQualitySessionTracking();
  captureUtmParams();
  // RUM code is split into its own chunk and only requested when GATSBY_RUM_PROVIDER is set at build time.
  if (process.env.GATSBY_RUM_PROVIDER) {
    import('src/functions/rum/initRum')
      .then(({ initRum }) => initRum())
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.warn('[rum] failed to load RUM chunk:', error && error.message ? error.message : error);
      });
  }
};

exports.wrapPageElement = ({ element, props }) => {
  return (
    <I18nProvider pageContext={props.pageContext}>
      <ContextProviders>{element}</ContextProviders>
    </I18nProvider>
  );
};

exports.onRouteUpdate = ({ location, prevLocation }) => {
  if (location && location.state && prevLocation) {
    location.state.referrer = prevLocation.pathname;
  }

  resetPageLoadTimestamp();
  resetScrollMilestones();
  incrementSessionPageCount();
  captureUtmParams();
  checkQualitySessionOnRouteUpdate();
  pushRouteUpdate(location, prevLocation);
};
